import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, commentId }) => {
  switch (type) {
    case drama.DELETE_DRAMA_COMMENT:
      return state.filter(id => id !== commentId);

    case drama.DELETE_DRAMA_COMMENT_FAILED:
      return [...state, commentId];

    default:
      return state;
  }
};